import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { Views, FORM_MODE } from '@awp/constants';
const SensorLink = ({ segment }) => {
  let isEmpty = false;
  if (
    isValueEmpty(segment.SensorId) &&
    (!segment.Sensor || isValueEmpty(segment.Sensor.ModelNumber)) &&
    (!segment.Sensor || isValueEmpty(segment.Sensor.Manufacturer))
  )
    isEmpty = true;

  return isEmpty ? (
    'No sensor associated'
  ) : (
    <Link to={Views.SensorEquipment} state={{ id: segment.SensorId, stateMode: FORM_MODE.VIEW }}>
      {`${segment.Sensor.SerialNumber} - ${segment.Sensor.ModelNumber} - ${segment.Sensor.Manufacturer}`}
    </Link>
  );
};

SensorLink.propTypes = {
  segment: PropTypes.any.isRequired,
};

export default SensorLink;
